import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Needs from "@/components/site/Needs";
import Roadmap from "@/components/site/Roadmap";
import Activities from "@/components/site/Activities";
import LifeAt from "@/components/site/LifeAt";
import InstagramFeed from "@/components/site/InstagramFeed";
import HowItWorks from "@/components/site/HowItWorks";
import NextEvents from "@/components/site/NextEvents";
import ParentSpace from "@/components/site/ParentSpace";
import About from "@/components/site/About";
import Support from "@/components/site/Support";
import Come from "@/components/site/Come";
import Faq from "@/components/site/Faq";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import TalkForm from "@/components/site/TalkForm";
import InscriptionDialog from "@/components/site/InscriptionDialog";

export default function Landing() {
  const [talkOpen, setTalkOpen] = useState(false);
  const [insActivity, setInsActivity] = useState(null);
  const location = useLocation();

  // Arrivée depuis une autre page avec une ancre (ex. /#activites)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 150);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  const openTalk = () => setTalkOpen(true);
  const closeTalk = () => setTalkOpen(false);
  const openInscription = (activity) => setInsActivity(activity);
  const closeInscription = () => setInsActivity(null);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main className="relative">
      <Header onTalk={openTalk} />
      <Hero onFindActivity={() => scrollTo("besoins")} onTalk={openTalk} />
      <Needs />
      <Roadmap />
      <Activities onTalk={openTalk} onRegister={openInscription} />
      <LifeAt />
      <InstagramFeed />
      <HowItWorks onTalk={openTalk} />
      <NextEvents />
      <ParentSpace />
      <About />
      <Support onTalk={openTalk} />
      <Come onTalk={openTalk} />
      <Faq />
      <FinalCTA onTalk={openTalk} />
      <Footer />

      <TalkForm open={talkOpen} onClose={closeTalk} />
      <InscriptionDialog open={Boolean(insActivity)} activity={insActivity} onClose={closeInscription} />
    </main>
  );
}
